import { useBaseApi } from "./BaseApiHook";

export interface SnykOrganization {
  SnykOrganizationID: string;
  SnykOrganizationName: string;
  LastUpdate: Date;
}

export interface SnykOrganizationCollection {
  SnykCollectionID: string;
  SnykOrganizationCollectionName: string;
  SnykOrganizationID: string;
  LastUpdate: Date;
}

export interface SnykIssue {
  id: number;
  organizationId: string;
  organizationName: string;
  collectionId: string;
  projectId: string;
  product: string; //TODO:: The EDR has this as an enum
  severity: string; //TODO:: The EDR has this as an enum
  firstIntroduced: Date;
  lastIntroduced: Date;
  lastIgnored: Date;
  lastResolved: Date;
  snykOrgCollName: string;
  problemTitle: string;
  issueStatus: string; //TODO:: The EDR has this as an enum
  issueURL: string
  directDependency: number;
}

export const useSnykApi = () => {
  const { request } = useBaseApi();

  return {
    GetIssues: async (productID: string): Promise<Array<SnykIssue>> => request("GET", "/issues/snyk/" + productID),
    GetCodeIssues: async (productID: string): Promise<Array<SnykIssue>> => request("GET", "/snyk/code/" + productID),
    GetSourceIssues: async (productID: string): Promise<Array<SnykIssue>> => request("GET", "/snyk/source/" + productID),
  }
}
